<template>
	<div class="help">
		<div class="help-warp">
			<ElRow class="title">
				<ElCol :span="24">
					<h2 class="title-text" v-if="!isPartner">{{$t('help.area')}}</h2>
					<div v-else>
						<p class="title-text">{{$t('help.company')}}</p>
						<p class="title-info">
							<strong>{{$t('help.helpContent')}}</strong>
						</p>
					</div>
				</ElCol>
			</ElRow>
			<template v-if="!isPartner">
				<div class="content">
					<ElRow class="info-warp">
						<template v-for="(item,index) in dataList">
							<ElCol :xs="24" :sm="24" :md="24/isCol" :lg="24/isCol" :xl="24/isCol">
								<div :key="index" class="content-warp">
									<h2 class="content-title">{{item.title}}</h2>
									<ul :style="{'height':maxLen*35+'px'}">
										<template v-for="(value,k) in item.list">
											<li :key="k" :class="{active: isClass && index==0}">{{value.title}}</li>
											<ul v-if="value.list">
												<template v-for="l in value.list">
													<li>{{l}}</li>
												</template>
											</ul>
										</template>
									</ul>
								</div>
							</ElCol>
						</template>
					</ElRow>
				</div>
			</template>
			<template v-else>
				<KllkForm :isTitle="false"></KllkForm>
			</template>
		</div>
	</div>
</template>
<script>
import KllkForm from '../../../components/kllk-form-warp'

export default {
	name: 'help',
	props: {
		dataList: {
			type: Array,
			default: () => {
				return []
			},
		},
		isPartner: {
			type: Boolean,
			default: false,
		},
		// 医学事务帮助我们，左侧颜色标黑
		isClass: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			maxLen: 3
		}
	},
	mounted() {
		let _arr = [];
		for (let i = 0; i <= this.dataList.length; i++) {
			if (this.dataList[i] && this.dataList[i].list) {
				_arr.push(this.dataList[i].list.length)
			}
		}
		this.maxLen = Math.max(..._arr);
	},
	components: { KllkForm },
	computed: {
		isCol() {
			return this.dataList.length > 4 ? 3 : this.dataList.length
		},
	},
}
</script>
<style lang='less' scoped>
@import "../../../style/constant.less";

.help {
	background-image: url("../../../assets/service/help.jpg");
	padding: 80px 0 120px;
	background-attachment: fixed;

	.help-warp {
		max-width: @page-width;
		margin: 0 auto;

		.title {
			text-align: center;
			font-weight: 500;
			margin-bottom: 10px;

			.title-text {
				line-height: 54px;
				font-style: normal;
				text-align: center;
				margin-bottom: 40px;
			}

			@media screen and (min-width: 320px) and (max-width: 480px) {
				.title-text {
					font-size: 26px;
					line-height: 30px;
					margin-bottom: 0px;
				}
			}

			.title-info {
				font-size: 21px;
				margin-top: 30px;
			}
		}
		@media screen and (min-width: 320px) and (max-width: 480px) {
			.title {
                padding: 30px;
                margin-bottom: 0px;
			}
		}

		.content {
			.content-warp {
				min-width: 25%;
				max-width: 100%;
				padding: 0 5px;
				color: @content-color;
				min-height: 100px;
				background: rgba(255, 255, 255, 1);
				/*height: 238px;*/
				border: 1px solid rgba(243, 243, 247, 1);
				border-left: 2px solid @primary-color;
				margin-right: 20px;

				h2 {
					font-weight: 400;
					color: @h1-color;
				}

				ul {
					padding-inline-start: 17px;
					padding: 0 20px 0 30px;

					li {
						padding: 7px 0;
						font-size: 14px;
						color: #5f6464;
					}

					.active {
						font-weight: 400;
						color: #333;
						list-style: none;
						font-size: 1.5em;
					}
				}
			}

			@media screen and (min-width: 320px) and (max-width: 480px) {
				.content-warp {
					margin: 10px;
				}
				.content-title {
					font-size: 18px;
				}

				.active {
					font-size: 18px !important;
					margin-left: -17px !important;
				}
			}
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.help {
		padding: 0px;
		.help-warp {
			margin-bottom: 50px;
		}
	}
}
</style>
